import { Component, OnInit } from '@angular/core';
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';
import { Offerte, OfferteObject } from 'src/app/shared/model/offerte';

@Component({
  selector: 'app-offerte-view',
  templateUrl: './offerte-view.component.html',
  styleUrls: ['./offerte-view.component.less']
})
export class OfferteViewComponent implements OnInit {

  list = null;
  currentRecord = 1;
  offerteID : number;


  constructor() { }

  ngOnInit(): void {
  }



  selectionChanged(data: Array<OfferteObject>) {
      this.list = data;
      if (data != null && data.length > 0)
        this.offerteID = data[0].ID;
  }

  objectChanged(data: any) {
    if (data.record)
      this.currentRecord = data.record;
    if (data.ID)
      this.offerteID = data.ID;

    console.log(this.offerteID)

  }

  offerteAdded(data:Offerte) {
      const object = new OfferteObject()
      object.ID = data.ID;
      object.ObjectID = data.ObjectID;
      this.list.unshift(object);
  }


}
